define("shared/components/shared/wizard/cancel-button", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @onCancel}}
    <Shared::Ui::Button
      @onClick={{action "cancelWizard"}}
      @text={{this.buttonText}}
      @variant="none"
      class={{if @buttonClass @buttonClass this.defaultClass}}
    />
  {{/if}}
  */
  {
    "id": "6TyoDnX0",
    "block": "[[[41,[30,1],[[[1,\"  \"],[8,[39,1],[[16,0,[52,[30,2],[30,2],[30,0,[\"defaultClass\"]]]]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,2],[[30,0],\"cancelWizard\"],null],[30,0,[\"buttonText\"]],\"none\"]],null],[1,\"\\n\"]],[]],null]],[\"@onCancel\",\"@buttonClass\"],false,[\"if\",\"shared/ui/button\",\"action\"]]",
    "moduleName": "shared/components/shared/wizard/cancel-button.hbs",
    "isStrictMode": false
  });
  let CancelButtonComponent = _exports.default = (_class = class CancelButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _defineProperty(this, "defaultClass", 'o--btn o--btn--outline u--p__lr__lg u--float--left qa--slide_cancel');
    }
    get defaultButtonText() {
      return this.intl.t('shared_words.cancel');
    }
    get buttonText() {
      return this.args.text ? this.args.text : this.defaultButtonText;
    }
    cancelWizard() {
      if (this.args.onCancel) {
        this.args.onCancel();
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "cancelWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelWizard"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CancelButtonComponent);
});